import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Radio,
  RadioGroup,
  Form,
  TranslationProvider,
} from '@resy/ui-kitchen';

import './BookingForm.scss';

import GuestInfoInput from '../GuestInfoInput';
import { IDLE } from '../../../../../ui-kitchen/src/constants/asyncLoadingStatuses';
import { loadResyConfigThunk } from '../../../../../ui-kitchen/src/reducers/resyConfigSlice';

class BookingForm extends React.Component {
  // TODO(CON-17456): Add concierge phone validation UX parity once prioritized
  // (too-long live checks, incomplete-on-submit, canonical phone errors).
  static propTypes = {
    bookOnBehalfOf: PropTypes.bool,
    info: PropTypes.shape({
      country_code: PropTypes.string,
      email: PropTypes.string,
      first_name: PropTypes.string,
      last_name: PropTypes.string,
      phone: PropTypes.string,
    }).isRequired,
    onBookingInfoChange: PropTypes.func.isRequired,
    onBookingTypeChange: PropTypes.func.isRequired,
    error: PropTypes.shape({
      serverError: PropTypes.bool,
      msg: PropTypes.string,
      keys: PropTypes.arrayOf(PropTypes.string),
    }),
    configStatus: PropTypes.string.isRequired,
    countryCodes: PropTypes.arrayOf(PropTypes.shape({})),
    dispatch: PropTypes.func.isRequired,
  }

  static defaultProps = {
    bookOnBehalfOf: true,
    error: {
      serverError: false,
      msg: '',
      keys: [],
    },
    countryCodes: [{ iso3166: 'US', code: '1', country_name: 'United States' }],
  }

  state = {
    defaultCountryCode: '1',
  }

  componentDidMount() {
    const { configStatus, dispatch } = this.props;
    if (configStatus === IDLE) {
      dispatch(loadResyConfigThunk());
    }
  }

  handleBookingTypeChange = (val) => {
    const { onBookingTypeChange } = this.props;

    onBookingTypeChange(val);
  }

  handleBookingInfoChange = (value) => {
    const { onBookingInfoChange } = this.props;
    onBookingInfoChange(value);
  }

  render() {
    const {
      defaultCountryCode,
    } = this.state;

    const {
      bookOnBehalfOf,
      countryCodes,
      error,
      info,
    } = this.props;

    return (
      <div className="BookingForm">
        <RadioGroup onChange={this.handleBookingTypeChange} aria-labelledby="concierge_section">
          <Radio
            checked={!bookOnBehalfOf}
            value={false}
            variant="input"
          >
            <TranslationProvider translationKey="concierge_book_for_me">
              <span>Book for me</span>
            </TranslationProvider>
          </Radio>
          <Radio
            checked={bookOnBehalfOf}
            value
            variant="input"
          >
            <TranslationProvider translationKey="concierge_book_on_behalf">
              <span>Book on behalf of another guest</span>
            </TranslationProvider>
          </Radio>
        </RadioGroup>

        {bookOnBehalfOf && (
          <>
            <TranslationProvider translationKey="concierge_book_on_behalf_info">
              <div className="BookingForm__blurb">
                Accurate guest information enables guest confirmations and reminders, and gives them the ability to change or cancel their reservation.
                GDA exclusive inventory may only be booked by a GDA member for the member&apos;s personal use.
              </div>
            </TranslationProvider>
            <Form
              name="booking_form"
              onChange={this.handleBookingInfoChange}
              error={error}
            >
              {({ onChange, errorKeys }) => (
                <GuestInfoInput
                  info={info}
                  onChange={onChange}
                  errors={errorKeys}
                  countryCodes={countryCodes}
                  defaultCountryCode={defaultCountryCode}
                />
              )}
            </Form>
          </>
        )}
      </div>
    );
  }
}

const mapStateToProps = ({ resyConfig }) => ({
  configStatus: resyConfig.configStatus,
  countryCodes: resyConfig.config?.country_codes,
});

BookingForm.displayName = 'BookingForm';

export { BookingForm as ComponentUnderTest };
export default connect(mapStateToProps)(BookingForm);
